import { AxiosResponse } from 'axios';
import {
  IStartSessionRequest,
  IStartSessionResponse,
  IEndSessionRequest,
  IEndSessionResponse,
  IGetActiveSessionResponse,
} from '../../../interface/paymentSession.interface';
import api from '../../api';

/**
 * Start a new payment session
 * @param data - Opening balance and optional session notes
 * @returns Promise with session data
 */
const startSession = async (
  data: IStartSessionRequest,
): Promise<AxiosResponse<IStartSessionResponse>> => {
  // Transform frontend field names to backend expected format
  const payload = {
    openingBalance: data.opening_balance,
    notes: data.session_notes,
  };

  const res: AxiosResponse<IStartSessionResponse> = await api.post(
    '/payment/session/start',
    payload,
  );
  return res;
};

/**
 * End an active payment session
 * @param sessionId - ID of the session to end
 * @param data - Actual cash count and optional closing notes
 * @returns Promise with session closure data including variance
 */
const endSession = async (
  sessionId: string,
  data: IEndSessionRequest,
): Promise<AxiosResponse<IEndSessionResponse>> => {
  // Transform frontend field names to backend expected format
  const payload = {
    closingBalance: data.actual_cash_count,
    notes: data.closing_notes,
  };

  const res: AxiosResponse<IEndSessionResponse> = await api.put(
    `/payment/session/end/${sessionId}`,
    payload,
  );
  return res;
};

/**
 * Get currently active payment session
 * @returns Promise with active session data or null
 */
const getActiveSession = async (): Promise<AxiosResponse<IGetActiveSessionResponse>> => {
  const res: AxiosResponse<IGetActiveSessionResponse> = await api.get('/payment/session/active');
  return res;
};

export const paymentSessionService = {
  startSession,
  endSession,
  getActiveSession,
};
